<!--//营业执照信息收集-->
<template>
  <div id="box">
    <div id="container">
      <myhead></myhead>
      <main>
        <div class="left_bg"></div>
        <div class="right_log">
          <div class="title">营业执照认证</div>
          <!-- <div class="desc"><p class="all">可使用嗖嗖人力部分功能，电子签约功能不可使用</p></div > -->
          <p class="message">请提交纳税人识别号，法人名称，法人身份证，以完成企业验证。</p>
          <div class="entry">
            <el-form
              ref="companyInfo"
              :rules="rules"
              :model="companyInfo"
              label-position="left"
            >
            <el-form-item  prop="name">
              <el-input
                placeholder="请输入公司全称"
                v-model="companyInfo.name"
                style="margin-bottom: 10px"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item  prop="unitType">
              <el-select
                v-model="companyInfo.unitType"
                style="margin-bottom: 10px;width:100%"
                placeholder="请选择单位类型"
              >
                <el-option label="普通企业" :value="0"></el-option>
                <el-option label="社会团体" :value="1"></el-option>
                <el-option label="事业单位" :value="2"></el-option>
                <el-option label="民办非企业单位" :value="3"></el-option>
                <el-option label="党政及国家机构" :value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item  prop="registerNumberType">
			
              <el-select
                v-model="companyInfo.registerNumberType"
                style="margin-bottom: 10px;width:100%"
                placeholder="请选择注册号类型"
              >
                <el-option label="组织机构代码号" :value="0"></el-option>
                <el-option label="多证合一，传递社会信用代码号" :value="1"></el-option>
                <el-option label="企业工商注册码" :value="2"></el-option>
              </el-select>
            </el-form-item>
              <!-- <el-input placeholder="请输入组织机构代码" v-model="companyInfo.orgCode" style="margin-bottom: 10px" clearable></el-input> -->
            <el-form-item  prop="registerNumber">
             
			  <el-input
                placeholder="请输入纳税人识别号"
                v-model="companyInfo.registerNumber"
                style="margin-bottom: 10px"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item  prop="registerType">

              <el-select
                v-model="companyInfo.registerType"
                style="margin-bottom: 10px;width:100%"
                placeholder="请选择注册类型"
              >
                <!-- <el-option label="代理人注册" :value="1"></el-option> -->
                <el-option label="法人注册" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item  prop="legalPersonPlace">

              <el-select
                v-model="companyInfo.legalPersonPlace"
                style="margin-bottom: 10px;width:100%"
                placeholder="请选择法人归属地"
              >
                <el-option label="大陆" :value="0"></el-option>
                <el-option label="香港" :value="1"></el-option>
                <el-option label="澳门" :value="2"></el-option>
                <el-option label="台湾" :value="3"></el-option>
                <el-option label="外籍" :value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item  prop="legalPerson">

              <el-input
                placeholder="请输入法人名称"
                v-model="companyInfo.legalPerson"
                style="margin-bottom: 10px"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item  prop="legalPersonIdnumber">

              <el-input
                placeholder="请输入法人身份证号"
                v-model="companyInfo.legalPersonIdnumber"
                style="margin-bottom: 10px"
                clearable
              ></el-input>
            </el-form-item>
            </el-form>
          </div>
          <div class="footerBtn">
            <!-- <button class="btn" type="button" @click="onreturn">返回上一步</button> -->
            <button class="btn subbtn" type="button" @click="onsubmit">提交</button>
          </div>
        </div>
      </main>
      <myfoot></myfoot>
    </div>
  </div>
</template>

<script>
export default {
  name: "LicenceCllect",
  data() {
    return {
		rules:{
      name: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur",
          },
        ],
        unitType: [
          {
            required: true,
            message: "请选择单位类型",
            trigger: "change",
          },
        ],
        registerNumberType: [
          {
            required: true,
            message: "请选择注册号类型",
            trigger: "blur",
          },
        ],
        registerNumber: [
          {
            required: true,
            message: "请输入纳税人识别号",
            trigger: "blur",
          },
        ],
        registerType: [
          {
            required: true,
            message: "请选择注册类型",
            trigger: "change",
          },
        ],
        legalPersonPlace: [
          {
            required: true,
            message: "请选择法人归属地",
            trigger: "change",
          },
        ],
        legalPerson: [
          {
            required: true,
            message: "请输入法人名称",
            trigger: "blur",
          },
        ],
          legalPersonIdnumber: [
          {
            required: true,
            message: "请输入法人身份证号",
            trigger: "blur",
          },
        ],
    },
      companyInfo: {
        id: this.$route.query.id,
        name: this.$route.query.name,
        unitType: "",
        legalPersonPlace: "",
        // orgCode:'',
        registerType: "",
        registerNumberType: "",
        registerNumber: "",
        legalPerson: "",
        legalPersonIdnumber: "",
      },
      typesOf: 0,
    };
  },
  mounted() {
    //this.typesOf = this.$route.query.typesOf;
  },
  methods: {
    onsubmit() {
       this.$refs.companyInfo.validate((valid) => {
        if (valid) {
      this.$axios
        .post("/companyContract/validAuth", this.companyInfo)
        .then((res) => {
          if (res.data.status == 1) {
            this.$message.success("企业信息验证成功");
            let authzId = res.data.data;
            if (res.data.data == 0) {
              var that = this;
              this.$router.push({
                path: "/accountCllect",
                query: {
                  id: this.$route.query.id,
                  name: this.$route.query.name,
                },
              });
            } else {
              this.$router.push({
                path: "/main/system/system/company",
              });
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
         }
      });
    },
    onreturn() {
      // 				this.$router.push({
      // 					path: '/setting/company'
      // 				})

      this.$router.back(-1);
    },
  },
};
</script>

<style scoped lang="less">
#app {
  position: relative;
}

#box {
  width: 100%;
  min-width: 1184px;
  background-color: #292b52;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: auto;

  #container {
    width: 1184px;
    margin: 0 auto;

    main {
      width: 100%;
      height: 560px;
      background-color: #fff;
      border-radius: 6px;
      display: flex;
      justify-content: space-around;

      /*overflow: hidden;*/
      .left_bg {
        width: 400px;
        height: 400px;
        background-image: url(../../../assets/img/1_10-12.png);
        margin: 6% 5px;
        background-repeat: no-repeat;
      }

      .right_log {
        width: 414px;
        height: 560px;
        margin-top: 30px;

        .desc {
          display: flex;
          align-items: center;
          color: #0bb27a;
          font-size: 14px;
          margin: 10px 0;
        }

        .desc:after {
          content: "";
          width: 40px;
          height: 1px;
          background-color: #a8a8b3;
          margin-left: 20px;
        }

        .desc:before {
          content: "";
          width: 40px;
          height: 1px;
          background-color: #a8a8b3;
          margin-right: 20px;
        }

        .message {
          font-size: 12px;
          color: #555;
          margin-bottom: 30px;
          margin-top: 30px;
          text-align: center;
        }

        .entry {
          margin: 10px 0;
          height: 200px;
          overflow-y: auto;
        }

        .footerBtn {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 20px;

          .btn {
            width: 100%;
          }

          .btn subbtn {
            width: 100%;
          }
        }

        .title {
          font-size: 30px;
          text-align: center;
          color: #000000;
          font-weight: bold;
          background-color: #fff;
          margin-top: 57px;
        }
      }
    }
  }
}

@media (min-height: 720px) {
  #container {
    width: 1184px !important;
    height: 720px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto !important;
  }
}
</style>
